import * as React from 'react';
import ContentCopy from '@mui/icons-material/ContentCopy';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { Button, Tooltip } from "@mui/material";
import { buildSchema,buildProperty, buildCollection,ExtraActionsParams } from "@camberi/firecms";
import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeApp, getApp } from "firebase/app";
import { getFirestore, collection as firestoreCollection, doc } from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig";





export default class Tournaments {

    constructor() {

    }

    static BuildCollection (isadmin:boolean, issuperadmin:boolean, groupname:string) {
      return buildCollection({
        path: "tournamentsDraft",
        description: "collection of drafts",
        group:groupname,
        exportable:false,
        schema: Tournaments.schema(),
        name: "Draft Mode",
        extraActions: Tournaments.actions,
        callbacks: {
          onPreSave: ({values, context}) => {
            if (values && values.rewards && Array.isArray(values.rewards)) {
              values.rewards = values.rewards.map((reward: any) => {
                if (!reward.guid) {
                  reward.guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                    return v.toString(16);
                  });
                }
                return reward;
              });
            }
            return values;
          }
        },
        permissions: ({entity,path,user,authController,context}) => { 
            return ({
                read: isadmin,
                create: isadmin,
                update: isadmin,
                delete: isadmin
            });
        },
      })
    }

  

    static schema () {
      return buildSchema({
          name: "Draft Mode",
          properties: {
            
            nameInternal: {
              title: "Name",
              dataType: "string"
            },
            nameLocalizationKey: {
              title: "Name localization key",
              dataType: "string"
            },



            descriptionInternal:{
              title: "Description internal",
              dataType: "string"
            },
            descriptionLocalizationKey:{
              title: "Description localization key",
              dataType: "string"
            },
            




            startDate: {
              title: "Start date",
              dataType: "timestamp"
            },
            endDate: {
              title: "End date",
              dataType: "timestamp"
            },

            ticketSaleStart: {
              title: "Ticket sale start",
              dataType: "timestamp",
             
            },
            ticketSaleEnd: {
              title: "Ticket sale end",
              dataType: "timestamp"
            },

            rewards: {
              title: "Rewards",
              
              dataType: "array",
              of: {
                dataType: "map",
                properties: {
                  matchesWon: {
                    title: "matches Won",
                    dataType: "number"
                  },
                  rewardSKU: {
                    title: "Reward SKU",
                    dataType: "string"
                  },
                  rewardAmount: {
                    title: "Reward amount",
                    dataType: "number"
                  },
                  guid: {
                    title: "GUID",
                    dataType: "string"
                  }
                }
              }
            },

            amountOfDraftedBoosters: {
              title: "nr. of packs",
              dataType: "number",
            },
            draftBoosterSKU: {
              title: "pack SKU",
              dataType: "array",
              of: {
                dataType: "string"
              }
            },
            
            guid: {
              title: "GUID",
              dataType: "string"
            },
            enableLeaderboard: {
              title: "Enable leaderboard",
              dataType: "boolean"
            },
          
            enableMatchHistory: {
              title: "Enable Match History",
              dataType: "boolean"
            },
            maxMatchesPerPlayer: {
              title: "matches per player",
              dataType: "number"
            },
            maxTicketSalesGlobal: {
              title: "Max tickets global",
              dataType: "number"
            },
            maxTicketSalesPerPlayer: {
              title: "tickets per player",
              dataType: "number"
            },
          }
        })
      }


            
           
            
            
            


    static matchSchema (title:string): any {
      return {
        dataType: "array",
        title: title,
        of: {
          dataType: "map",
          properties: {
            matchStatus: {
              title: "match status",
              dataType: "string",
            },

            sides: {
              dataType: "array",
              title: "sides",
              of: {
                dataType: "map",
                properties: {
                  userid: {
                    title: "user ID",
                    dataType: "string",
                  },  
                  score: {
                    title: "score",
                    dataType: "number",
                  },  
                  
                  isWinner: {
                    title: "is Winner",
                    dataType: "boolean"
                  }
                }
              } 
            }
            
          }
        }
      }
    }

    static actions(extraActionParams: ExtraActionsParams) {
      let disabled = (extraActionParams.selectionController.selectedEntities.length == 0) ? true : false;
      
      const duplicateDocument = async () => {
        if (extraActionParams.selectionController.selectedEntities.length == 0) return;
        
        const selectedEntity = extraActionParams.selectionController.selectedEntities[0];
        const dataSource = extraActionParams.context.dataSource;
        const snackbar = extraActionParams.context.snackbarController;
        const entityCollection = extraActionParams.collection;
        
        try {
          // Generate a new document ID
          let app;
          try {
            app = getApp();
          } catch {
            app = initializeApp(firebaseConfig);
          }
          const db = getFirestore(app);
          const newDocId = doc(firestoreCollection(db, selectedEntity.path)).id;
          
          const entityData = selectedEntity.values;
          const newData = { ...entityData };
          
          // Set GUID to the new document ID
          newData.guid = newDocId;
          
          // Set public to false
          newData.public = false;
          
          if (newData.nameInternal) {
            newData.nameInternal = `${newData.nameInternal} (Copy)`;
          }
          
          await dataSource.saveEntity({
            path: selectedEntity.path,
            entityId: newDocId,
            values: newData,
            status: "new",
            schema: entityCollection.schema
          });
          
          snackbar.open({
            type: "success",
            title: "Duplicate",
            message: "Draft duplicated successfully"
          });
        } catch (error) {
          snackbar.open({
            type: "error",
            title: "Error",
            message: `Failed to duplicate draft: ${error}`
          });
        }
      };

      const copyToLive = async () => {
        if (extraActionParams.selectionController.selectedEntities.length == 0) return;
        
        const selectedEntity = extraActionParams.selectionController.selectedEntities[0];
        const snackbar = extraActionParams.context.snackbarController;
        const user = extraActionParams.context.authController.user;
        
        if (!user) {
          snackbar.open({
            type: "error",
            title: "Error",
            message: "User not authenticated"
          });
          return;
        }
        
        try {
          let app;
          try {
            app = getApp();
          } catch {
            app = initializeApp(firebaseConfig);
          }
          const functions = getFunctions(app, "europe-west3");
          const copyToLiveFunction = httpsCallable(functions, "copyDocumentToLive");
          
          await copyToLiveFunction({
            props: {
              collection: "tournamentsDraft"
            },
            userID: user.uid,
            documentID: selectedEntity.id
          });
          
          snackbar.open({
            type: "success",
            title: "Copy to Live",
            message: "Draft copied to live project successfully"
          });
        } catch (error) {
          snackbar.open({
            type: "error",
            title: "Error",
            message: `Failed to copy draft to live: ${error}`
          });
        }
      };

      return [
        <Tooltip title="Duplicate selected draft" key="duplicate-tip">
          <Button disabled={disabled} onClick={duplicateDocument} color="primary" key="duplicate">
            <ContentCopy />
          </Button>
        </Tooltip>,
        <Tooltip title="Copy selected draft to live project" key="copy-live-tip">
          <Button disabled={disabled} onClick={copyToLive} color="primary" key="copy-live">
            <CloudUpload />
          </Button>
        </Tooltip>
      ];
    }

    
}